import axiosIns from '@/libs/axios'

export default {
  namespaced: true,
  state: {
    sectors: [],
    sectorsCount: 0,
    sector: {},
    sectorSave: {
      message: null,
      status: null,
      id: null,
    },
  },
  getters: {
    getSectors(state) {
      return state.sectors
    },
    getSectorsCount(state) {
      return state.sectorsCount
    },
    getSector(state) {
      return state.sector
    },
    getSectorSaveStatus(state) {
      return state.sectorSave
    },
  },
  mutations: {
    SECTORS_LIST(state, data) {
      state.sectors = data
    },
    SECTOR_VIEW(state, data) {
      state.sector = data
    },
    SECTORS_COUNT(state, data) {
      state.sectorsCount = data
    },
    SECTOR_SAVE(state, data) {
      state.sectorSave = data
    },
  },
  actions: {
    sectorsList({ commit }, params) {
      const data = JSON.stringify(params)
      axiosIns
        .post('/defines/sectors/getData', data)
        .then(response => {
          commit('SECTORS_LIST', response.data.data)
          commit('SECTORS_COUNT', response.data.count)
        })
        .catch(error => console.error(error))
    },
    sectorView({ commit }, id) {
      const data = JSON.stringify({
        where: {
          'sectors.id': id,
        },
        array: false,
      })
      axiosIns
        .post('/defines/sectors/getData', data)
        .then(response => {
          commit('SECTOR_VIEW', response.data.data)
        })
        .catch(error => console.error(error))
    },
    sectorSave({ commit }, postData) {
      const data = JSON.stringify({ formData: postData })
      axiosIns
        .post('/defines/sectors/saveData', data)
        .then(response => {
          commit('SECTOR_SAVE', response.data)
        })
        .catch(error => console.error(error))
    },
  },
}
